'use strict';

exports.__esModule = true;
exports.default = restrictNumbers;

var _useReversedNumbers = require('./useReversedNumbers');

/**
 * Restrict the numbers (start, end) within the provided boundaries (min, max).
 * The numberStart and numberEnd will be moved in parallel such that they fit.
 *
 * The numbers will not fit when end - start is larger than max - min, in that
 * case numberStart will be set to numberMin, and the numberEnd will overflow.
 *
 * @param {number} xStart
 * @param {number} xEnd
 * @param {number} minNumber
 * @param {number} maxNumber
 * @returns {{xStart: number, xEnd: number}}
 */
function restrictNumbers(xStart, xEnd, minNumber, maxNumber) {
  if ((0, _useReversedNumbers.useReversedNumbers)(minNumber, maxNumber)) {
    var _updated = restrictReversedNumberMin(xStart, xEnd, minNumber);
    return restrictReversedNumberMax(_updated.xStart, _updated.xEnd, maxNumber);
  }

  var updated = restrictNumberMax(xStart, xEnd, maxNumber);
  return restrictNumberMin(updated.xStart, updated.xEnd, minNumber);
}

function restrictNumberMax(xStart, xEnd, maxNumber) {
  if (xEnd > maxNumber) {
    var diff = maxNumber - xEnd;
    return {
      xStart: xStart + diff,
      xEnd: xEnd + diff
    };
  } else {
    return { xStart: xStart, xEnd: xEnd };
  }
}

function restrictNumberMin(xStart, xEnd, minNumber) {
  if (xStart < minNumber) {
    var diff = minNumber - xStart;
    return {
      xStart: xStart + diff,
      xEnd: xEnd + diff
    };
  } else {
    return { xStart: xStart, xEnd: xEnd };
  }
}

function restrictReversedNumberMin(xStart, xEnd, minNumber) {
  if (xStart > minNumber) {
    var diff = xStart - xEnd;
    return {
      xStart: minNumber,
      xEnd: minNumber - diff
    };
  } else {
    return { xStart: xStart, xEnd: xEnd };
  }
}

function restrictReversedNumberMax(xStart, xEnd, maxNumber) {
  if (xEnd < maxNumber) {
    var diff = xStart - xEnd;
    return {
      xStart: maxNumber + diff,
      xEnd: maxNumber
    };
  } else {
    return { xStart: xStart, xEnd: xEnd };
  }
}